


















































    import AbpBase from "../../../lib/abpbase"
    import {Component} from "vue-property-decorator"
    import AddOrEdit from './parts/addOrEdit.vue'
    import Syn from './parts/syn.vue'
    import itemSyn from './parts/itemSyn.vue'
    import {QueryDeleteSysDic, QueryMaterials, QuerySysDic} from "../../../api/material"
    @Component({
        components:{AddOrEdit,Syn,itemSyn}
    })
    export default class MaterialClass extends AbpBase{
        addOrEditShow = false
        addOrEditData: any = {}
        synShow = false
        synData:any = {}
        itemSynShow = false
        itemSynData:any = {}
        types = []
        query = {
            materialName: '',
            type: 0,
            manufacturer: '',
            status: true,
	        page: 1,
            pageSize: 10
        }
        selection:any = []
        selectionChange(selection:any){
            console.log(selection)
            this.selection = selection
        }

        created() {
            this.getSelects()
            this.getData()
        }

        addOne() {
            this.addOrEditData = {
                mode: 'add',
            }
            this.addOrEditShow = true
        }
        rowSyn(row){
            this.itemSynData = row
            this.itemSynShow = true
        }
        columns = [
            {
                title: '编号',
                key: 'code'
            },
            {
                title: '物资名称',
                key: 'name'
            },
            {
                title: '物资类型',
                key: 'typeName'
            },
            {
                title: '物资分类',
                key: 'categoryName'
            },
            {
                title: '所属类型名称',
                key: 'pTypeName'
            },
            {
                title: '状态',
                render: (h: any, p: any) => {
                    return h('span', p.row.status)
                }
            },
            {
                title:'是否已同步',
                render: (h: any, p: any) => {
                    return h('el-tag', {
                        props: {
                            type: p.row.synStatus ? 'success' : 'danger',
                        },
                    }, p.row.synStatus ? '已同步' : '未同步' )
                }
            },
            {
                title: '操作',
                width: 150,
                render: (h: any, p: any) => {
                    return h('div', [
                        h('el-button', {
                            props: {type: 'text'},
                            directives:[{
                                name:'allow'
                            }],
                            on: {
                                click: () => {
                                    this.rowSyn(p.row)
                                }
                            }
                        }, '同步'),
                        h('el-button', {
                            props: {type: 'text'},
                            directives:[{
                                name:'allow'
                            }],
                            on: {
                                click: () => {
                                    this.$message({
                                        type:'info',
                                        customClass:'messagez',
                                        message:'编辑后将自动同步修改内容到已同步的中心',
                                    })
                                    this.editOne(p)
                                }
                            }
                        }, '编辑'),
                        h('el-button', {
                            props: {type: 'error'},
                            directives:[{
                                name:'allow'
                            }],
                            on: {
                                click:async ()=>{
                                    this.$confirm('确认要删除吗？',{
                                        confirmButtonText:this.L('Yes'),
                                        cancelButtonText:this.L('No')})
                                        .then(async () => {
                                            let res = await QueryDeleteSysDic({id:p.row.id})
                                            this.getData()
                                        })
                                        .catch(() => {

                                        });
                                }
                            }
                        }, '删除'),
                        // h('el-button', {
                        //     props: {type: 'text'},
                        //     on: {
                        //         click: () => {
                        //             this.syn(p)
                        //         }
                        //     }
                        // }, '同步')
                    ])
                }
            }
        ]
        data = []

        async getData() {
            this.table.loading = true
            let res = await QueryMaterials({...this.query,...this.table})
            this.table.totalCount = res.data.totalCount;
            this.data = res.data.items
            this.table.loading = false
        }
        pageChange(page:number){
            this.table.page = page
            this.getData();
        }
        pagesizeChange(pagesize:number){
            this.table.pageSize = pagesize
            this.getData();
        }
        private async getSelects() {
            let res = await QuerySysDic({
                "dataType": 1,
                "typeName": "",
                "status": true
            })
            this.types = res.data
        }
        syn(){
            if(this.selection.length===0){
                this.$message.warning('请选择物资')
                return false
            }
            this.synData = this.selection.map(item=>{return item.id})
            this.synShow = true
        }
        private editOne(p:any) {
            this.addOrEditData = {
                mode: 'edit',
                data: {...p.row, materialName:p.row.name}
            }
            this.addOrEditShow = true
        }
    }
